import React, { Component } from 'react';
import './HeroHome.css';

export default class HeroHome extends Component {

  render () {
    return (
        <div id="hero-home">
            <h1 className="hero-title">Design &amp; <br />Develop</h1>
            <p>We're not into buzz words or tech jargon. We look for real <br />solutions to very real business challenges.</p>
        </div>
    );
  }
}
